import { ConsoleUI } from "./ConsoleUI";
const readline = require('readline');

export class ConsoleUiWin implements ConsoleUI {
    
    loaderStart(message: string): void {
        console.log(`${message}...`);
    }    
    
    loaderFail(message: string): void {
        console.log(`Error: ${message}`);
    }

    loaderSuccess(message: string): void {
        console.log(`Success: ${message}`);
    }

    log(message: any): void {
        console.log(message);
    }
    
    promptList(message: string, choices: any[]): Promise<any> {
        throw new Error("Method not implemented.");
    }
    promptInput(message: string): Promise<string> {
        throw new Error("Method not implemented.");
    }
    promptConfirm(message: string): Promise<boolean> {
        throw new Error("Method not implemented.");
    }
    promptCheckbox(message: string, choices: any[]): Promise<string> {
        throw new Error("Method not implemented.");
    }



}






/*
console.log("::::");
question("quindi? semplifichiamo?").then(res => {
	
	console.log("-----");
	console.log(res);
	console.log("-----");
	
	
	return question("Pensi di essere pronto?").then(mah => {
		console.log("appunto");
		console.log(mah);
		
	});
	
}).then(aa => {
	console.log("fine?");
});
console.log("::::");
*/